module.exports = __webpack_public_path__ + "static/flooring-design-new-d98d8562c56ca74cee2a5be5511fa6b9.png";